import QEAxios from "../../axios";

export const DUPLICATE_REF_TOOLTIP =
  "This Q-number is used by more than one quote. Please verify the quote before sharing with the client.";

export function normalizeQuotationNumber(value) {
  if (value === null || value === undefined) {
    return null;
  }

  const str = String(value).trim();
  if (str === "" || str === "—") {
    return null;
  }

  const parsed = parseInt(str, 10);
  return Number.isNaN(parsed) ? str : String(parsed);
}

export function buildDuplicateRefSet(quotes) {
  if (!quotes || !quotes.length) {
    return new Set();
  }

  const refToVersionIds = new Map();

  quotes.forEach((quote) => {
    const ref = normalizeQuotationNumber(quote.reference && quote.reference.quotation_number);
    if (ref === null) {
      return;
    }

    const versionId = quote.version_quote_id;
    if (!refToVersionIds.has(ref)) {
      refToVersionIds.set(ref, new Set());
    }
    refToVersionIds.get(ref).add(versionId);
  });

  const duplicates = new Set();
  refToVersionIds.forEach((versionIds, ref) => {
    if (versionIds.size > 1) {
      duplicates.add(ref);
    }
  });

  return duplicates;
}

export function isDuplicateRef(quotationNumber, duplicateRefSet) {
  const ref = normalizeQuotationNumber(quotationNumber);
  if (ref === null || !duplicateRefSet) {
    return false;
  }

  return duplicateRefSet.has(ref);
}

export async function fetchDuplicateRefSet() {
  try {
    const response = await QEAxios.get("list.php");
    if (response.data && response.data.status === "success") {
      return buildDuplicateRefSet(response.data.data);
    }
  } catch (e) {
    console.error(e);
  }

  return new Set();
}
